import { findManyCategories } from "app/data/categories/category.validators"
import { imageSelectVX } from "app/data/image/image.validators"
import { articleTagsVX } from "app/data/tag/tag.validators"
import { Prisma } from "db"

const ArticleIsValidWhere: Prisma.ArticleWhereInput = {
  NOT: {
    pages: {
      some: {
        leadImage: null,
      },
    },
  },
  publishedAt: {
    not: null,
  },
}

const ArticleWhereV = (where?: Prisma.ArticleWhereInput) => {
  return Prisma.validator<Prisma.ArticleWhereInput>()({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    AND: [where as any, ArticleIsValidWhere],
  })
}

const pageTranslationsSelectVX = Prisma.validator<Prisma.ArticlePageLocalizedFindManyArgs>()({
  orderBy: { locale: "asc" },
  select: {
    content: true,
    locale: true,
    summary: true,
    title: true,
  },
})

const articleTranslationsSelectVX = Prisma.validator<Prisma.ArticleLocalizedFindManyArgs>()({
  orderBy: { locale: "asc" },
  select: { locale: true, slug: true },
})

const articlePageVX = Prisma.validator<Prisma.ArticlePageFindManyArgs>()({
  orderBy: { number: "asc" },
  select: {
    id: true,
    leadImage: imageSelectVX,
    number: true,
    translations: pageTranslationsSelectVX,
  },
})

const articleSelectX = Prisma.validator<Prisma.ArticleSelect>()({
  authors: { select: { name: true } },
  categories: findManyCategories,
  createdAt: true,
  id: true,
  isValid: true,
  pages: articlePageVX,
  publishedAt: true,
  tags: articleTagsVX,
  translations: articleTranslationsSelectVX,
  updatedAt: true,
})

export const ArticleFindManyVX = (where?: Prisma.ArticleWhereInput) =>
  Prisma.validator<Prisma.ArticleFindManyArgs>()({
    orderBy: { publishedAt: "desc" },
    select: articleSelectX,
    where: ArticleWhereV(where),
  })

export const getArticleBySlugArgs = (slug: string) =>
  Prisma.validator<Prisma.ArticleFindFirstArgs>()({
    select: articleSelectX,
    where: {
      translations: {
        some: {
          slug,
        },
      },
    },
  })

export const articlePathsArgs = Prisma.validator<Prisma.ArticleFindManyArgs>()({
  orderBy: { publishedAt: "desc" },
  select: {
    _count: { select: { pages: true } },
    translations: {
      orderBy: { locale: "asc" },
      select: { locale: true, slug: true },
    },
    updatedAt: true,
  },
  where: ArticleWhereV(),
})

export const getCategoryArgsArticles = (categoryIds: number[]) =>
  Prisma.validator<Prisma.ArticleFindManyArgs>()({
    ...ArticleFindManyVX({
      categories: {
        some: {
          OR: categoryIds.map((categoryId) => ({
            idPath: { has: categoryId },
            publishedAt: { not: null },
          })),
        },
      },
    }),
    take: 5,
  })
